<template>
  <section>
    <div class="grid-cols-[1fr_50%] gap-12 md:grid lg:grid-cols-[1fr_65%]">
      <header class="mb-6">
        <p class="font-title mb-3 text-2xl/normal lg:text-3xl/normal">
          Une offre pensée pour répondre à vos besoins
        </p>

        <h2 class="text-lg">
          Programmes, formations ou masterclass, nous développons des parcours
          sur-mesure pour vos talents.
        </h2>
      </header>

      <div class="@container">
        <dl
          class="@xl:grid-cols-[repeat(var(--columnCount),1fr)] grid gap-6"
          :style="{
            '--columnCount': list.length,
          }"
        >
          <div
            v-for="item in list"
            :key="item.title"
            class="@xl:flex-col @xl:items-center @xl:text-center @xl:text-balance flex gap-3"
          >
            <app-icon class="@xl:!block !hidden" :icon="item.icon" :size="54" />

            <div>
              <dt
                class="@xl:justify-center flex items-center gap-2 text-lg font-semibold"
              >
                <app-icon class="@xl:!hidden" :icon="item.icon" :size="24" />

                {{ item.title }}
              </dt>
              <dd>
                {{ item.subtitle }}
              </dd>

              <app-button class="mt-3" color="dark" size="lg" :to="item.to">
                Découvrir
              </app-button>
            </div>
          </div>
        </dl>
      </div>
    </div>

    <app-image
      alt=""
      class="mt-8 aspect-[2.6] rounded-lg rounded-br-[theme(spacing.12)] object-cover max-sm:hidden lg:mt-12"
      src="https://res.cloudinary.com/dfdgwwkpd/image/upload/v1748428500/brand/home/IMG_3995_1_1_ssz48e.jpg"
      :width="1920"
    />
  </section>
</template>

<script lang="ts" setup>
import { iconFillVariant } from "@pollen/ui-library";

import { type RouteLocationRaw } from "#vue-router";

const { data } = useCategoryPageList();

const list = computed<
  {
    title: string;
    subtitle: string;
    icon: string;
    to: RouteLocationRaw;
  }[]
>(() => {
  return data.value.map((page) => {
    return {
      title: page.title_short,
      subtitle: page.subtitle,
      icon: iconFillVariant(page.tag.icon),
      to: page._links.page,
    };
  });
});
</script>
